import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  unassigned: 'Unassigned',
  activeSim: 'Active SIM',
  deactivatedSim: 'Deactivated SIM',
})
